import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { CoreState } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";

@Injectable({
	providedIn: "root",
})
export class RouteQueryGuard implements CanActivate {
	constructor(private store: Store<CoreState>) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		if (!route.queryParams?.route) {
			return true;
		}

		this.store.dispatch(
			RouteAction.navigate(route.queryParams.route, undefined, { queryParamsHandling: "preserve" })
		);
		return false;
	}
}
